const PATHS = {
  ROOT: '/',
  CALLBACK: '/callback',
  DASHBOARD: '/dashboard',
  CHANGE_PASSWORD: '/change-password',
  NOT_FOUND: '/not-found',
  ROUTES_NOT_REGISTERED: '/**',
};

export default PATHS;
